import React from 'react';

/**
 * Skeleton para el gráfico "Evolución por día" en Analytics.
 * Mantiene la misma estructura visual: título, selects de métricas, área del gráfico.
 */
const EvolutionChartSkeleton = () => {
  return (
    <div className="mt-8 sm:mt-12">
      <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl p-4 sm:p-6 shadow-lg transition-all duration-500 ease-out">
        <div className="relative z-10">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
            <div>
              <div className="h-6 w-40 bg-white/20 rounded animate-pulse mb-2" />
              <div className="w-16 h-0.5 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full" />
            </div>
            <div className="flex items-center gap-3 flex-wrap sm:flex-nowrap">
              <div className="flex items-center gap-2">
                <div className="h-4 w-16 bg-white/20 rounded animate-pulse" />
                <div className="h-9 w-36 bg-white/10 rounded-lg animate-pulse" />
              </div>
              <div className="flex items-center gap-2">
                <div className="h-4 w-16 bg-white/20 rounded animate-pulse" />
                <div className="h-9 w-36 bg-white/10 rounded-lg animate-pulse" />
              </div>
            </div>
          </div>
          {/* Área del gráfico (line chart) - misma altura que el real (320px) */}
          <div className="w-full h-[320px] flex items-end gap-1 px-2">
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                className="flex-1 bg-white/10 rounded-t animate-pulse"
                style={{
                  height: `${30 + (i % 5) * 15}%`,
                  animationDelay: `${i * 50}ms`
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EvolutionChartSkeleton;
